import { FC, SVGProps } from 'react';

export const UserOutlined: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.9453 20.6017C12.7773 20.6017 9 20.9841 9 22.8044C9 24.639 12.7773 25.0241 15.9453 25.0241C19.1133 25.0241 22.8893 24.643 22.8893 22.8266C22.8893 20.988 19.1133 20.6017 15.9453 20.6017ZM15.9453 26.9889C13.7333 26.9889 7 26.9889 7 22.8048C7 18.6378 13.7333 18.6378 15.9453 18.6378C18.1573 18.6378 24.8893 18.6378 24.8893 22.8271C24.8893 26.9889 18.392 26.9889 15.9453 26.9889Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.9452 6.96387C13.6892 6.96387 11.8545 8.76712 11.8545 10.9829C11.8505 12.0567 12.2692 13.0612 13.0359 13.8194C13.8025 14.5776 14.8239 14.998 15.9119 15.0019L15.9452 15.9841V15.0019C18.2012 15.0019 20.0372 13.2 20.0372 10.9829C20.0372 8.76712 18.2012 6.96387 15.9452 6.96387ZM15.9452 16.9667H15.9092C14.2825 16.9615 12.7585 16.3355 11.6172 15.2041C10.4732 14.0739 9.84788 12.5732 9.85454 10.9794C9.85454 7.68459 12.5865 5 15.9452 5C19.3052 5 22.0372 7.68459 22.0372 10.9834C22.0372 14.2821 19.3052 16.9667 15.9452 16.9667Z"
			fill="currentColor"
		/>
	</svg>
);
